module.exports = __webpack_public_path__ + "static/media/eServices – Arabic.15d74a53.jpg";